<template>
    <Toast />
    <div class="login-body">
        <div class="login-wrapper">
            <div class="login-panel">
                <a @click="goDashboard" class="logo">
                    <img src="assets/layout/images/logininside.png" alt="InsideJob"
                        style="margin-bottom: 20px; height: 50px" />
                    <!-- <h3 style="color:#002; line-height:0.5em;">InsideJob Admin</h3> -->
                    <!-- <p>로그인을 해주세요</p> -->
                </a>
                <div class="input_group">
                    <InputText id="username" :placeholder="$t('button.ID')" v-model="username"
                        :class="`${error.email ? 'p-invalidusername' : ''}`" />
                    <span><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAB/ElEQVRYhe3XS2sUURAF4M9ETXRMzEJE3QiiCIpuVFBBEMWt+EDBhbjS8bV0pbh2YUAEwb/gf3CpIRDjYGJEBEkIPpYmaHxAxHHR1TgZZibdkzQq5EBx6b5Vp05fbtW9zRL+Q/TiNiqYCRvEdawsOvlOvEO1iVWwqajkazERiZ7iMFajByfwOuaeK2glbkaCUXQ1EZiKuFaEgEqQH2/hczJ8BosQ8DXI17fw6Q2fz1lJOxYoqh7L8gbkEfAmxv0tfI7GOJZXSBbMtwn7JCKruFqEgF5/ynAAR1CK96dqkg9jRRECSBrRpOaNaBgbi0qeoge3ItmXsAHJshf25f8sOsPaRp663YZjOIQd2II1MTeDcbzCEzzG24UIS9GFMoY03nQ/wxrNDeGSxiWbCafN3fFTeBSk+yR1n6Iv3pXDZ6ombjK4cqG/huAFzqE7R3x3xIzU8NzNGlyOgO+4rI3+XoMOXAmuKi5mCUqX/cwCEtfjbHBOZHFO1a5aRAGl4PxWP9HoNByN8cIiCjgf40gW5/RWM4v7kppvF3vxILiqwT0HzTbYDdzB8ngel1xExyQN5j2mJTefUviskxxEW7EHB7E55mYlx3l/HvW78BCfND/95rMPuKfFKmYpsU7sxgFsl7TgDZJbcAk/wm8aHyX/DRU8w0v8yvS5S/hb+A1AGJjvDKXBKQAAAABJRU5ErkJggg=="></span>
                </div>
                <div class="text-redx">{{ error.email }}</div>
                <div class="text-redx">{{ email_err }}</div>

                <div class="input_group">
                    <Password @keyup.enter="Login" id="password" :placeholder="$t('button.Password')" :feedback="false"
                        v-model="password" :class="`${error.password ? 'p-invalid' : ''}`" toggle-mask />
                    <span><img
                            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAA8klEQVRIie3UTUrDUBQF4I9sQAWRkm7IOnOgoKBD0RVEcJKRuDhFXILttGipTpRiHSQp9fHSpilOtAfO5N7DuT+Pd9ng36GDHA94wxD3uClza+EYr5jWcIjDtuZHmCwwrzjBwarmnSWdhxxhp6l5gitsz8U+kaFb8rqMVdjC5SoTPAYdZhFNpvmEFQfowXuQSCMF0hYFpugniof7NSR4DmJnEd15C+8BLuDOz7E+FDtPS2ZlbF6TRwzD9czQxTgiqOML9mo6nu0+TJ7iq4H5RP1v7pVF+tiPCU6WTDJaYN4YKW7xpDh2Y8Wxy7G7rvkGfxTfJruHfBnjM6AAAAAASUVORK5CYII="></span>

                    <div class="text-redx">{{ error.password }}</div>
                    <div class="text-redx">{{ pass_err }}</div>
                </div>
                <div class="p-d-flex p-jc-between p-mb-2">
                    <div class="field-checkbox" style="text-align: left; padding-bottom: 10px; width: 50%;">
                        <Checkbox id="rem" :binary="true" v-model="remember" @change="rememberMe()"></Checkbox>
                        <label for="rem" style="padding-left: 5px">{{ $t('button.remember') }}</label>
                    </div>
                    <router-link :to="'/forgotpassword'">
                        <div class="fpass"><u>{{ $t('button.forgotpass') }}</u></div>
                    </router-link>
                </div>
                <Button :label="$t('button.login')" type="button" @click="Login" class="colorchange"></Button>
                <!-- <a href="#" @click="open">{{ $t('Forget Password') }}</a> -->
                <!-- <a href="#">forget dfc password?</a> -->
                <!-- <p>Don’t you have an account, <a href="#">sign up</a></p> -->
            </div>
        </div>
        <Dialog :header="$t('password.recovery_DFC')" v-model:visible="display" :breakpoints="{ '960px': '75vw' }"
            :style="{ width: '30vw' }" :modal="true">
            <div class="p-field p-fluid">
                <label for="username">{{ $t('password.p_email') }}:</label>
                <InputText :class="`${error.resetemail ? 'p-invalid' : ''}`" id="username" type="email"
                    v-model="resetemail" />
                <small v-show="helptxt">{{ $t('password.help') }}</small>
                <div class="text-redx">{{ error.resetemail }}{{ errmsg }}</div>
            </div>
            <template #footer>
                <Button :label="$t('password.send_mail')" @click="resetpass" icon="pi pi-check"
                    class="p-button-primary" />
                <!-- <Button label="Dismiss" @click="close" icon="pi pi-pi-times" class="p-button-danger" /> -->
            </template>
        </Dialog>
    </div>

</template>

<script>
import validateLogin from '../validations/validateLogin';
import validateReset from '../validations/validateReset';
import axios from 'axios';
export default {
    data() {
        return {
            errmsg: '',
            helptxt: true,
            resetemail: '',
            display: false,
            email_err: '',
            pass_err: '',
            username: '',
            password: '',
            type: '',
            error: {},
            errors: {},
            remember: true,
        };
    },
    mounted() {
        this.remember = localStorage.getItem('save') == 'true' ? true : false;
        if (localStorage.getItem('save') == 'true') {
            this.username = localStorage.getItem('Uid');
            this.password = localStorage.getItem('Upass');
        }
    },
    methods: {
        rememberMe() {
            localStorage.setItem('save', this.remember);
            if (this.remember == true) {
                localStorage.setItem('Uid', this.username);
                localStorage.setItem('Upass', this.password);
            } else {
                localStorage.removeItem('Uid');
                localStorage.removeItem('Upass');
            }
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        async Login() {
            let credentials = {
                email: this.username,
                password: this.password,
            };
            const { isInvalid, error } = validateLogin(credentials);
            if (isInvalid) {
                this.error = error;
                console.log(error);
            } else {
                var self = this;
                this.error = {};
                // console.log('pass');
                await axios({
                    method: 'post',
                    url: '/api/v1/admin/user/login',
                    data: credentials,
                })
                    .then(function (response) {
                        // console.log(response.data);
                        localStorage.setItem('token', response.data.accessToken);
                        localStorage.setItem('AdminName', response.data.name);
                        localStorage.setItem('AdminId', response.data.username);
                        localStorage.setItem('admin-type', response.data.type);
                        localStorage.setItem('admin-ID', response.data.id);
                        if (response.data.type == 'admin') {
                            // window.location = localStorage.getItem("DynamicPath");
                            window.location = '/SubAdmin';

                            // console.log(localStorage.getItem("DynamicPath"))
                        } else {
                            window.location = '/';
                        }
                    })
                    .catch(function (err) {
                        console.log(err);
                        self.$toast.add({ severity: 'error', summary: '인증 실패', detail: '잘못된 사용자 이름 또는 암호를 입력했습니다.', life: 3000 });
                    });
            }
        },
        resetpass() {
            let vcheckData = {
                resetemail: this.resetemail,
            };
            const { isInvalid, error } = validateReset(vcheckData);
            if (isInvalid) {
                this.error = error;
                this.helptxt = false;
                // console.log(error);
            } else {
                this.errmsg = '';
                let self = this;
                this.helptxt = true;
                this.error = {};
                axios({
                    method: 'post',
                    url: '/admin/dfc/resetPassword',
                    data: { email: this.resetemail },
                })
                    .then(function () {
                        self.close();
                        self.$toast.add({ severity: 'success', summary: '비밀번호가 성공적으로 변경되었습니다', detail: ` 새로운 비밀번호가 ${self.resetemail}로 발송되었습니다  `, life: 5000 });
                    })
                    .catch((err) => {
                        this.helptxt = false;
                        this.errmsg = err.response.data.message;
                    });
            }
        },
        goDashboard() {
            window.location = '/';
        },
    },
};
</script>
<style scoped>
.colorchange:focus {
    background-color: #fff;
    color: blue;
}

.p-invalidusername {
    border: 1px solid red !important;
}

/* input#username {
    max-width: 70%;
}

.login-body .login-wrapper .login-panel>div {
    max-width: 295px;
    width: 85%;
} */
</style>
